import { ProgressBar, Spinner, useValidatedState } from "acma-spa";
import React, { useState } from "react";
import * as yup from 'yup';
import { Finish } from "../components/finish";
import { MessageDetails } from "../components/message-details";
import { PersonalDetails } from "../components/personal-details";
import { Welcome } from "../components/welcome";
import { ISPAMComplaint, SPAMComplaint } from "../models/Models";

export interface AppProps {
    baseUrl: string;
}

const submissionSchema: yup.ObjectSchema<ISPAMComplaint> = yup.object().shape({
    
}).defined();

export const App = (props: AppProps) => {

    const [submission, setSubmission, errors, validate] = useValidatedState<ISPAMComplaint>(SPAMComplaint.fromJS({}), submissionSchema);
    const [stage, setStage] = useState<number>(1);
    const handleNext = async () => {
        setStage(stage < 4 ? stage + 1 : stage);
        window.scrollTo(0, 0);
    };
    const handlePrevious = async () => {  
        setStage(stage > 1 ? stage - 1 : stage);
        window.scrollTo(0, 0);
    };
    const [isLoading, setIsLoading] = useState<boolean>(false);

    return (
        <>
            <Spinner isLoading={isLoading}>
            <ProgressBar current={stage} total={4} />
                <div id="container">
                    {stage == 1 && 
                        <Welcome
                        onNext={handleNext}
                        onPrevious={handlePrevious} submission={undefined} />
                    }
                    {stage == 2 &&
                        <PersonalDetails
                        submission={submission}
                        onChange={(submission: ISPAMComplaint) => {
                            setSubmission({
                                ...submission
                            })
                        }}
                            onNext={handleNext}
                            onPrevious={handlePrevious} />}
                    {stage == 3 &&
                        <MessageDetails
                        baseUrl={props.baseUrl}
                        submission={submission}
                        onChange={(submission: ISPAMComplaint) => {
                            setSubmission({
                                ...submission
                            })
                            }}
                        onNext={handleNext}
                            onPrevious={handlePrevious} />}
                    {stage == 4 && 
                        <Finish/>
                    }
            </div>
            </Spinner>
        </>
    );
};
